const ENC = new TextEncoder();
const ESC = 0x1b, GS = 0x1d;
const SERVICES = ["000018f0-0000-1000-8000-00805f9b34fb", "e7810a71-73ae-499d-8c15-faa9aef0c3f2", "49535343-fe7d-4ae5-8fa9-9fafd205e455", "0000ff00-0000-1000-8000-00805f9b34fb"];
let device = null, characteristic = null;

const rp = (n) => "Rp" + Number(n || 0).toLocaleString("id-ID");
const pad = (l, r, w = 32) => { l = String(l); r = String(r); const sp = Math.max(1, w - l.length - r.length); return l.slice(0, w - r.length - 1) + " ".repeat(sp) + r; };
const wrap = (t, w = 32) => { const out = []; let s = String(t || ""); while (s.length > w) { out.push(s.slice(0, w)); s = s.slice(w); } out.push(s); return out; };

export const buildReceiptBytes = (r) => {
  const parts = [];
  const raw = (...b) => parts.push(Uint8Array.from(b));
  const txt = (t = "") => parts.push(ENC.encode(t.normalize("NFKD").replace(/[^\x00-\x7F]/g, "") + "\n"));
  raw(ESC, 0x40); raw(ESC, 0x61, 1); raw(ESC, 0x45, 1); raw(GS, 0x21, 0x11);
  txt(r.workshop_name || "MJM WORKSHOP");
  raw(GS, 0x21, 0x00); raw(ESC, 0x45, 0);
  txt("STRUK PEMBAYARAN"); txt(r.receipt_number || ""); txt("");
  raw(ESC, 0x61, 0);
  txt(`Tgl : ${new Date(r.paid_at).toLocaleString("id-ID", { dateStyle: "short", timeStyle: "short" })}`);
  txt(`Plg : ${r.customer || "Umum"}`);
  if (r.wo_number) { txt(`WO  : ${r.wo_number}`); txt(`Unit: ${r.plate || ""} ${r.vehicle || ""}`.trim()); } else txt("Penjualan sparepart");
  txt(`Inv : ${r.invoice_number}`); txt("-".repeat(32));
  (r.lines || []).forEach((l) => { wrap(l.name).forEach((w) => txt(w)); (l.components || []).forEach((c) => wrap(` - ${c.name} x${c.qty}`).forEach((w) => txt(w))); txt(pad(`  ${l.qty} x ${rp(l.unit_price)}`, rp(l.subtotal ?? l.qty * l.unit_price))); });
  txt("-".repeat(32));
  txt(pad("Subtotal", rp(r.subtotal)));
  if (r.discount > 0) txt(pad("Diskon", "-" + rp(r.discount)));
  raw(ESC, 0x45, 1); raw(GS, 0x21, 0x01); txt(pad("TOTAL", rp(r.total), 32)); raw(GS, 0x21, 0x00); raw(ESC, 0x45, 0);
  txt(pad(`Bayar (${r.method})`, rp(r.total)));
  if (r.reference) txt(`Ref : ${r.reference}`);
  txt(`Kasir: ${r.cashier || ""}`); txt("");
  raw(ESC, 0x61, 1); txt("Terima kasih!"); txt("Garansi jasa 7 hari"); txt(""); txt(""); txt("");
  raw(GS, 0x56, 0x42, 0x00);
  const total = parts.reduce((a, p) => a + p.length, 0);
  const out = new Uint8Array(total); let o = 0;
  parts.forEach((p) => { out.set(p, o); o += p.length; });
  return out;
};

export const isBluetoothSupported = () => typeof navigator !== "undefined" && !!navigator.bluetooth;

async function connect() {
  if (characteristic && device?.gatt?.connected) return characteristic;
  if (!device) device = await navigator.bluetooth.requestDevice({ acceptAllDevices: true, optionalServices: SERVICES });
  device.addEventListener("gattserverdisconnected", () => { characteristic = null; });
  const server = await device.gatt.connect();
  const services = await server.getPrimaryServices();
  for (const svc of services) {
    const chars = await svc.getCharacteristics();
    const ch = chars.find((c) => c.properties.writeWithoutResponse || c.properties.write);
    if (ch) { characteristic = ch; return ch; }
  }
  throw new Error("Printer tidak punya karakteristik tulis (bukan printer ESC/POS BLE?)");
}

export const printBluetooth = async (receipt) => {
  if (!isBluetoothSupported()) throw new Error("Browser tidak mendukung Web Bluetooth. Gunakan Chrome/Edge di Android/Windows/Mac (bukan iPhone).");
  const ch = await connect();
  const bytes = buildReceiptBytes(receipt);
  const CHUNK = 100;
  for (let i = 0; i < bytes.length; i += CHUNK) {
    const slice = bytes.slice(i, i + CHUNK);
    if (ch.properties.writeWithoutResponse) await ch.writeValueWithoutResponse(slice); else await ch.writeValue(slice);
    await new Promise((res) => setTimeout(res, 25));
  }
  return device?.name || "printer";
};

export const forgetPrinter = () => { try { device?.gatt?.disconnect(); } catch { /* ignore */ } device = null; characteristic = null; };
export const printerName = () => device?.name || null;
